import { errorHandler } from "./index69.js";
import { TechSpaceErrorType } from "./index68.js";
function implementSizeConstraints(sizeInfo, maxHeight, maxDepth, forceInvalid = false) {
  const area = sizeInfo.area;
  const sizeX = sizeInfo.sizeX;
  let sizeY = sizeInfo.sizeY;
  let sizeZ = sizeInfo.sizeZ;
  let invalidated = false;
  if (maxHeight >= sizeInfo.sizeY[0]) {
    sizeY = [Math.min(maxHeight, sizeInfo.sizeY[1]), Math.min(maxHeight, sizeInfo.sizeY[1])];
  } else if (forceInvalid) {
    sizeY = [maxHeight, maxHeight];
    invalidated = true;
  } else {
    const error = errorHandler(TechSpaceErrorType.Size, {
      errorDimension: "SizeY",
      spaceRequired: sizeInfo,
      invalidatedSize: false
    });
    return { success: false, error };
  }
  if (maxDepth >= sizeInfo.sizeZ[0]) {
    sizeZ = [sizeInfo.sizeZ[0], Math.min(maxDepth, sizeInfo.sizeZ[1])];
  } else if (forceInvalid) {
    sizeZ = [maxDepth, maxDepth];
    invalidated = true;
  } else {
    const error = errorHandler(TechSpaceErrorType.Size, {
      errorDimension: "SizeZ",
      spaceRequired: sizeInfo,
      invalidatedSize: false
    });
    return { success: false, error };
  }
  return {
    success: true,
    size: {
      area,
      sizeX,
      sizeY,
      sizeZ
    },
    invalidated
  };
}
export {
  implementSizeConstraints
};
//# sourceMappingURL=index147.js.map
